import s from "./CrtFilter.module.scss";

const CrtFilter= () => {

    return (
        <div className={s.crt}></div>
    );
};

export default CrtFilter;